export enum InventoryCondition {
  NEW = "New",
  USED = "Used",
  AS_IS = "As is",
}
